import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Contact from './pages/Contact';
import ConnectedDevices from './pages/ConnectedDevices';
import WebApps from './pages/WebApps';
import MentionsLegales from './pages/MentionsLegales';
import NotFound from './pages/NotFound';
import  TodosContextProvider from './store/todo_context'
import './i18n';



function App() {
    return (
    <>
   <Router basename="">
    <TodosContextProvider>
      <Routes>
        <Route path='/'  element={<Home/>}/>
        <Route path='/Contact'  element={<Contact/>}/>
        
        <Route path='/Connected-Devices'  element={<ConnectedDevices/>}/>
        <Route path='/web-apps'  element={<WebApps/>}/>

        <Route path='/Mentions-Legales'  element={<MentionsLegales/>}/>
        <Route path='*' element={<NotFound/>}/>
      </Routes>
      </TodosContextProvider>
   </Router>
    </>
  );
}

export default App;
